import React from "react";
import { cardStyle } from "../../pages/Places/PlacesTable";

export function FormSection({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children: React.ReactNode;
}) {
  return (
    <section style={cardStyle} className="mb-3">
      <div className="mb-3 pb-2" style={{ borderBottom: "1px solid #f0f0f0" }}>
        <h6 className="fw-bold mb-0" style={{ fontSize: 15 }}>
          {title}
        </h6>
        {description && (
          <div className="text-muted" style={{ fontSize: 12 }}>
            {description}
          </div>
        )}
      </div>
      <div className="row g-3">{children}</div>
    </section>
  );
}

export function Field({
  label,
  htmlFor,
  required,
  hint,
  error,
  col = "col-md-6",
  children,
}: {
  label: string;
  htmlFor?: string;
  required?: boolean;
  hint?: string;
  error?: string;
  col?: string;
  children: React.ReactNode;
}) {
  return (
    <div className={col}>
      <label
        htmlFor={htmlFor}
        className="d-block mb-1 fw-semibold"
        style={{ fontSize: 13 }}
      >
        {label}
        {required && <span style={{ color: "#dc3545" }}> *</span>}
      </label>
      {children}
      {error ? (
        <div style={{ color: "#dc3545", fontSize: 12 }} className="mt-1">
          {error}
        </div>
      ) : (
        hint && (
          <div className="text-muted mt-1" style={{ fontSize: 12 }}>
            {hint}
          </div>
        )
      )}
    </div>
  );
}
